var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 15,
    fill: "#F7F6F6",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24085_72922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8133 8.5H21.1133L16.0884 14.2434L22 22.0586H17.3712L13.7459 17.3186L9.59772 22.0586H7.29616L12.6708 15.9155L7 8.5H11.7461L15.0231 12.8324L18.8133 8.5ZM18.006 20.6818H19.2806L11.0536 9.8045H9.68603L18.006 20.6818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24085_72922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13.5586,
    fill: "white",
    transform: "translate(7 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.a92ab921.svg";
export { ForwardRef as ReactComponent };